<template>
   <div>
        <div class="sysName">SIM连接管理平台</div>
        <div class="user">
            <span class="user-icon"> 
                <i class="el-icon-s-custom"></i>                    
            </span>
            <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                    {{ nickName }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="modifyPwd">
                        <svg class="se-icon" aria-hidden="true">
                            <use xlink:href="#se-icon-modify-password"></use>
                        </svg> 
                        <span>修改密码</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="useEmails">
                        <svg class="se-icon" aria-hidden="true">
                            <use xlink:href="#se-icon-modify-password"></use>
                        </svg> 
                        <span>设置邮箱</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="logout">
                        <svg class="se-icon" aria-hidden="true">
                            <use xlink:href="#se-icon-exit"></use>
                        </svg>
                        <span>退出</span>
                    </el-dropdown-item>
                </el-dropdown-menu>   
            </el-dropdown>
        </div>
       
        <el-dialog title="修改密码" :visible.sync="modifyPwdVisible"  width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="modifyPwdForm" :model="modifyPwdForm" :rules="pwdRules" label-width="100px">
                <el-form-item label="老密码：">
                    <el-input v-model="modifyPwdForm.oldPwd" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="新密码：">
                    <el-input v-model="modifyPwdForm.newPwd" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="newPwdAgain">
                    <el-input v-model="modifyPwdForm.newPwdAgain" show-password clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="modifyPwdHandle">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="设置邮箱" :visible.sync="updateEmails"  width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="modifyPwdForm" :model="modifyPwdForm" :rules="pwdRules" label-width="100px">
                <el-form-item label="邮箱：">
                    <el-input v-model="emails" ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="updateEmailsss">确 定</el-button>
            </div>
        </el-dialog>
        
    </div>

</template>

<script>
// import Router from "../../router";
import {getUserInfo, modifyPwd} from '@/api/user.js'
import {agentHomeNotify, agentHomeNotifyReaded} from '@/api/system.js'
import { mapGetters, mapMutations } from "vuex";
import common from '@/utils/common.js'
export default {
    data(){
        var checkPwd = (rule, value, callback) => {
            if(value != this.modifyPwdForm.newPwd){
                return callback(new Error('两次输入密码不一致'))
            }
            callback();
        };

        return {
            nickName: '',
            accountName: '',
            modifyPwdVisible:false,
            updateEmails:false,
            emails:'',
            modifyPwdForm: {
                id: '',
                oldPwd: '',
                newPwd: '',
                newPwdAgain: ''
            },
            pwdRules: {
                newPwdAgain: [
                    {validator: checkPwd, trigger: 'blur'}
                ]
            },
            oneNotify: '',
            notifyId: ''
        }
    },
  methods: {
        ...mapGetters("menu", {
            getNickName: "getNickName",
        }),
        ...mapMutations('menu', {
            addTab: 'addTab',
            switchTab: 'switchTab'
        }),
        handleCommand(command){
            switch (command) {
                case 'modifyPwd':
                    this.modifyPwdVisible = true;
                    break;
                case 'logout':
                    this.logoutHandler();
                    break;
                case 'useEmails':
                    this.useEmmailss();
                    break;
                default:
                    break;
            }
        },
        cancel(){
            for(var key in this.modifyPwdForm){
                this.modifyPwdForm[key] = '';
            }
            this.$refs['modifyPwdForm'].resetFields();
            this.modifyPwdVisible = false;
            this.updateEmails=false;
        },
        useEmmailss(){
            common.sysRequest('/agent/select/emails', {}, 'post').then(res => {
            if(res.data.code == 200){
                this.emails = res.data.data;
            }
            this.updateEmails=true;

        });    },
         updateEmailsss(){
            common.sysRequest('/agent/update/emails', {"emails":this.emails}, 'post').then(res => {
            if(res.data.code == 200){
                 this.$message.success('设置成功!')
            }else{
                 this.$message.error(res.data.message)
            }
            this.updateEmails=false;

        });    },
        modifyPwdHandle(){
            this.$refs.modifyPwdForm.validate(valid => {
                if(valid) {
                    this.modifyPwdForm.id = this.$store.state.menu.id;
                    modifyPwd(this.modifyPwdForm).then(res => {
                        var code = res.data.code;
                        if(code == 200){
                            this.$message.success('修改密码成功!')
                        }else{
                            this.$message.error(res.data.message)
                        }
                        this.modifyPwdVisible = false;
                    })                    
                }
            })
        },
        logoutHandler(){
            if(this.oneNotify){
                this.oneNotify.close();
            } 
            var menuState = this.$store.state.menu;
            for(var key in menuState){
                switch (typeof(menuState[key])) {
                    case 'string':
                        menuState[key] = ''
                        break;
                    case 'object':
                        menuState[key] = []
                        break;
                    default:
                        break;
                }
            }
            let loginAccounts = localStorage.getItem('loginAccounts');//记住账号
            localStorage.clear();
            if(loginAccounts!=null && loginAccounts!=undefined && loginAccounts.length > 0){
                this.setAutoCompleteData("loginAccounts",loginAccounts);
            }
            this.$router.push('/');
        },
        getAgentNotify(){
            agentHomeNotify({}).then(res => {
                if(res.data.code == 200){
                    if(res.data.data){
                        this.notifyId = res.data.data.id;
                        const h = this.$createElement;
                        this.oneNotify = this.$notify({
                            title: res.data.data.title,
                            dangerouslyUseHTMLString: true,
                            message: h('div', null, [
                                        h('div', null, [
                                            h('span', {style: 'font-size: 12px'}, `${res.data.data.currentTime}`),
                                            h('el-checkbox', {
                                                style: 'float: right',
                                                on: {
                                                    change: this.notifyReadedHandler
                                                } 
                                            }, '已读')
                                        ]),
                                        h('div', {
                                            domProps: {
                                                'innerHTML': `${res.data.data.content.replace(/\n/g, '<br>')}` 
                                            }
                                        })
                                    ]),
                            position: 'bottom-right',
                            duration: 0
                        })
                    }
                }
            })
        },
        notifyReadedHandler(){
            var data = {
                id: this.notifyId,
                accountName: this.accountName
            }
            agentHomeNotifyReaded(data)
        }
    },
    created(){
        var data = {
            id: localStorage.getItem('id')
        }
        getUserInfo(data).then(res => {
            if(res.data.code == 200){
                var result = res.data.data;                
                this.nickName = result.nickName;
                this.accountName = result.accountName;
                var roles = result.roles;
                roles.forEach(item => {
                    if(item.id == 100){
                        this.getAgentNotify();
                    }
                }); 

                var firstList = result.userMenus[0].bodyMenus[0];
                var tab = this.$store.state.menu.tabs.find(f => f.index == firstList.id)
                if(!tab){
                    var newTab = {
                        label: firstList.name,
                        index: firstList.id,
                        component: 'views/' + firstList.path
                    }
                    this.addTab(newTab)
                }
                this.switchTab(firstList.id)
            }else{
                this.$message.error(res.data.message)
            }
        })
    }
};
</script>

<style scoped>
    .sysName{
        display: inline-block;
        height: 60px;
        width: 50%;
        line-height: 60px;
        font-size: 20px;
        /* color: #fff; */
        color: #6C6D7B;
    }

    .user{
       display: inline-block;
       /* color: #fff;  */
        color: #6C6D7B;
       float: right;
    }
    
    .el-header .user .el-dropdown-link {
        /* color: #ffffff; */
        color: #6C6D7B;
        cursor: pointer;
        margin-right: 8px;
    }
</style>
